import EventEmitter from 'eventemitter3';
import { Settings } from '../../Settings';
import { MediaPacketFragmenter } from './MediaPacketFragmenter';
export class MediaPacketizer extends EventEmitter {
    mediaPacketFragmenter;
    mediaPacketCounter = 0;
    audioFrameBuffer = [];
    isVideoActive = false;
    constructor() {
        super();
        this.mediaPacketFragmenter = new MediaPacketFragmenter();
        this.audioFrameBuffer = new Array();
    }
    addVideoFrame(videoFrame, mediaStreamId) {
        const mediaPacket = {
            packetNumber: BigInt(this.mediaPacketCounter++),
            videoFrames: [videoFrame],
            audioFrames: this.audioFrameBuffer,
            mediaStreamId,
        };
        this.audioFrameBuffer = [];
        const fragments = this.mediaPacketFragmenter.fragmentMediaPacket(mediaPacket);
        for (const fragment of fragments) {
            this.emit('mediaPacketFragment', fragment);
        }
    }
    addAudioFrames(audioFrames, mediaStreamId) {
        if (!this.isVideoActive) {
            const mediaPacket = {
                packetNumber: BigInt(this.mediaPacketCounter++),
                audioCodec: Settings.audioCodec,
                videoFrames: [],
                audioFrames: audioFrames,
                mediaStreamId,
            };
            const fragments = this.mediaPacketFragmenter.fragmentMediaPacket(mediaPacket);
            for (const fragment of fragments) {
                this.emit('mediaPacketFragment', fragment);
            }
        }
        else {
            this.audioFrameBuffer.push(...audioFrames);
        }
    }
    setIsVideoActive(isVideoActive) {
        console.log('setIsVideoActive', isVideoActive);
        this.isVideoActive = isVideoActive;
    }
}
